import React from 'react';

function About() {
  return (
    <section id="about" className="px-10 py-4 m-auto bg-white sm:shadow-md sm:w-2/3">
      <h2 className="w-full text-3xl font-bold ">About</h2>
      <p>
        Hello! I'm Joshua Rieth, a freelance Full Stack Web Developer based in Henry
        County, KY. My goal is to build applications that are accessible to everyone!
      </p>
    </section>
  );
}

export default About;
